import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "tenants",
  class: "tenants"
}
const _hoisted_2 = {
  key: 1,
  class: "content"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "ellipsis-cell" }
const _hoisted_5 = { class: "ellipsed" }
const _hoisted_6 = { class: "ellipsis-cell" }
const _hoisted_7 = { class: "ellipsed" }
const _hoisted_8 = { class: "ellipsis-cell" }
const _hoisted_9 = { class: "ellipsed" }
const _hoisted_10 = { class: "row-hvcenter" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_Badge = _resolveComponent("Badge")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Button = _resolveComponent("Button")
  const _component_Empty = _resolveComponent("Empty")
  const _component_Column = _resolveComponent("Column")
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_AddModal = _resolveComponent("AddModal")
  const _component_EditModal = _resolveComponent("EditModal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode(" Loading"),
            _createElementVNode("br", null, null, -1 /* HOISTED */),
            _createTextVNode(" Please wait... ")
          ])),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("header", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "title" }, "Tenants", -1 /* HOISTED */)),
            ($options.total)
              ? (_openBlock(), _createBlock(_component_Badge, {
                  key: 0,
                  gray: "",
                  style: {"width":"max-content"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.total), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          (!$options.total)
            ? (_openBlock(), _createBlock(_component_Empty, {
                key: 0,
                bg: "assets/bg-pattern-decorative.png"
              }, {
                title: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("There are no tenants at the moment")
                ])),
                image: _withCtx(() => [
                  _createVNode(_component_Icon, {
                    width: "4rem",
                    height: "4rem",
                    icon: "user-03",
                    "stroke-width": "1",
                    stroke: "var(--gray-500)"
                  })
                ]),
                actions: _withCtx(() => [
                  _createVNode(_component_Button, {
                    primary: "",
                    onClick: $options.onAddTenant
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        icon: "plus",
                        width: "2rem",
                        height: "2rem",
                        stroke: "var(--base-white)"
                      }),
                      _cache[3] || (_cache[3] = _createTextVNode(" Add Tenant "))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])
                ]),
                _: 1 /* STABLE */
              }))
            : (_openBlock(), _createBlock(_component_DataTable, {
                key: 1,
                items: $options.view_items,
                total: $options.view_total,
                lazy: false,
                class: "table",
                onRowDblclick: $options.onRowDblclick
              }, {
                "header-right": _withCtx(() => [
                  _createVNode(_component_Button, {
                    tiny: "",
                    primary: "",
                    disabled: $options.refreshing,
                    gap: "0.6rem",
                    onClick: $options.onAddTenant
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        class: "pointer",
                        icon: "plus",
                        width: "1.6rem",
                        height: "1.6rem",
                        stroke: "var(--base-white)"
                      }),
                      _cache[4] || (_cache[4] = _createTextVNode(" Add Tenant "))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["disabled", "onClick"])
                ]),
                empty: _withCtx(() => [
                  _createVNode(_component_Empty, { bg: "assets/bg-pattern-decorative.png" }, {
                    title: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("No tenants were found")
                    ])),
                    image: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        width: "4rem",
                        height: "4rem",
                        icon: "user-03",
                        "stroke-width": "1",
                        stroke: "var(--gray-500)"
                      })
                    ]),
                    actions: _withCtx(() => [
                      _createVNode(_component_Button, {
                        primary: "",
                        onClick: $options.onAddTenant
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Icon, {
                            icon: "plus",
                            width: "2rem",
                            height: "2rem",
                            stroke: "var(--base-white)"
                          }),
                          _cache[6] || (_cache[6] = _createTextVNode(" Add Tenant "))
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onClick"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "name",
                    style: {"width":"25%"}
                  }, {
                    header: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode(" Name ")
                    ])),
                    body: _withCtx(({data: {name}}) => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(name), 1 /* TEXT */)
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_Column, {
                    field: "email_domain",
                    style: {"width":"25%"}
                  }, {
                    header: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode(" Domain ")
                    ])),
                    body: _withCtx(({data: {email_domain}}) => [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(email_domain), 1 /* TEXT */)
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_Column, {
                    field: "shared_company_id",
                    style: {"width":"30%"}
                  }, {
                    header: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode(" Shared Company ")
                    ])),
                    body: _withCtx(({data: {shared_company_name, shared_company_linkedin_id}}) => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, _toDisplayString(shared_company_name) + " " + _toDisplayString(shared_company_linkedin_id ? ' (' + shared_company_linkedin_id + ')' : ''), 1 /* TEXT */)
                      ])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_Column, {
                    field: "created_at",
                    style: {"width":"15%"}
                  }, {
                    header: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode(" Date Added ")
                    ])),
                    body: _withCtx(({data: {created_at}}) => [
                      _createTextVNode(_toDisplayString(_ctx.$utils.format.date(created_at)), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_Column, null, {
                    body: _withCtx(({data: {id}}) => [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_IconAsButton, {
                          icon: "pencil-02",
                          onClick: $event => ($options.onEditTenant(id))
                        }, null, 8 /* PROPS */, ["onClick"]),
                        _createVNode(_component_IconAsButton, {
                          icon: "settings-02",
                          onClick: $event => ($options.onGoToTenant(id))
                        }, null, 8 /* PROPS */, ["onClick"])
                      ])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["items", "total", "onRowDblclick"])),
          (_ctx.mounted)
            ? (_openBlock(), _createBlock(_component_AddModal, {
                key: 2,
                ref: "addModal",
                onSubmit: $options.onNewTenant
              }, null, 8 /* PROPS */, ["onSubmit"]))
            : _createCommentVNode("v-if", true),
          (_ctx.mounted)
            ? (_openBlock(), _createBlock(_component_EditModal, {
                key: 3,
                ref: "editModal",
                onSubmit: $options.onUpdateTenant
              }, null, 8 /* PROPS */, ["onSubmit"]))
            : _createCommentVNode("v-if", true)
        ]))
  ]))
}